import { eulaAgreementConstants } from '../constants';

type EulaAgreementUiState =
  (typeof eulaAgreementConstants)[keyof typeof eulaAgreementConstants];

interface AgreementState {
  userAgreement?: unknown;
  isEulaAgreed?: boolean;
  [key: string]: unknown;
}

// need to tell the client when it should indicate a spinning state while user-agreement API
// requests complete
// if there is an agreement and the user has not agreed to the latest agreement, then render
// the agreement UI
// if the user has agreed to the agreement, the UI should then proceed
export function eulaAgreementUiState(
  agreementState: AgreementState,
): EulaAgreementUiState {
  if (agreementState.userAgreement && !agreementState.isEulaAgreed) {
    return eulaAgreementConstants.needsToAgree;
  }
  if (agreementState.isEulaAgreed) {
    return eulaAgreementConstants.agreed;
  }
  return eulaAgreementConstants.waitingForApiResponses;
}

/**
 * returns returns the three possible states needed by the UI
 * <p>
 * @param {Object} getEulaAgreementUiState - the derived status
 */

export const getEulaAgreementUiState = eulaAgreementUiState;
